import Chart from 'react-apexcharts';
import { colors } from '@src/css_config/colorConstants.js';
import { chartFontFamily, chartFontStyle, defectAnalyticsLabel } from '@common/ui-constants';

function DefectsCycleChartYearMonths(props) {
  // TODO :: cycle time options for 1 to 7 days :: START

  let index = props.categories.length - 1;
  let date1 = props.categories[0];
  let date2 = props.categories[index];

  let optionsForMonthYearLineChart = {
    series: props.series,
    chart: {
      type: 'line',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
        tools: {
          download: false,
        },
      },
    },

    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      fontSize: '10px',
      fontFamily: chartFontFamily,
      offsetY: 8,
    },
    colors: colors.defectscycleTimeColor,

    stroke: {
      curve: 'smooth',
      lineCap: 'round',
      width: 3,
    },
    xaxis: {
      type: 'datetime',
      min: new Date(date1).getTime(),
      max: new Date(date2).getTime(),
      categories: props.categories,
      axisTicks: {
        show: false,
      },
      marker: {
        show: false,
      },
      title: {
        text: defectAnalyticsLabel.label.DATE_RANGE,
        offsetY: 4,
        ...chartFontStyle,
      },
      labels: {
        style: {
          color: colors.black,
          fontSize: '10px',
          fontFamily: chartFontFamily,
        },
        formatter: (value) => {
          const categoryTime = new Date(value);
          return categoryTime.toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' });
        },
      },
    },
    yaxis: {
      title: {
        text: defectAnalyticsLabel.label.NUMBER_OF_DEFECTS,
        ...chartFontStyle,
      },
      labels: {
        style: {
          color: colors.black,
          fontSize: '10px',
          fontFamily: chartFontFamily,
        },
      },
    },
    tooltip: {
      shared: true,
      enabled: true,
      onDatasetHover: {
        highlightDataSeries: true,
      },
      style: {
        fontSize: '10px',
        fontFamily: chartFontFamily,
      },
      x: {
        show: true,
        style: {
          fontSize: '10px',
          fontFamily: chartFontFamily,
        },
      },
      y: {
        show: true,
        style: {
          fontSize: '10px',
          fontFamily: chartFontFamily,
        },
      },

      marker: {
        show: true,
      },
    },
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: false,
        },
      },
      padding: {
        right: 60,
      },
    },
  };

  // TODO :: cycle time options for 1 to 7 days :: END

  return (
    <div className=" w-full overflow-hidden">
      <Chart
        options={optionsForMonthYearLineChart}
        series={optionsForMonthYearLineChart.series}
        type="line"
        height="250px"
      />
    </div>
  );
}
export default DefectsCycleChartYearMonths;
